import Alerta from '@/model/Alerta'
import Configuracion from '@/model/Configuracion'
import Denuncia from '@/model/Denuncia'
import { uiStore } from '@/store'
import { OptionalId } from '@pjn/core/model/helpers/Types'

export function mapAlertasTo(alert: any): Alerta {
  const alerta: Alerta = {
    vencidas: alert.vencidas,
    porVencer: alert.porVencer,
    configuracion: mapConfigsTo(alert.configuracion),
    hoy: new Date(alert.hoy)
  }
  return alerta
}

export function mapConfigsTo(configs: any): Configuracion {
  const configuracion: Configuracion = {
    id: configs.id,
    mail: configs.emailDestino,
    vigenciaAnios: configs.vigenciaAnios,
    proximas: {
      dias: configs.venceEnDias,
      frecuencia: configs.vencerFrec
    },
    vencidas: {
      frecuencia: configs.venciadaFrec
    }
  }
  return configuracion
}

export function mapConfigsFrom(configs: Configuracion) {
  const configuracion = {
    id: configs.id,
    vigenciaAnios: configs.vigenciaAnios,
    emailDestino: configs.mail,
    venceEnDias: configs.proximas.dias,
    vencerFrec: configs.proximas.frecuencia,
    venciadaFrec: configs.vencidas.frecuencia
  }
  return configuracion
}

export function mapDenunciaFrom(item: OptionalId<Denuncia>): any {
  try {
    let denuncia: any = {
      expediente: item.expediente,
      magistrado: item.magistrado,
      estado: item.estado,
      altaFecha: item.altaFecha,
      juzgado: item.juzgado,
      supuestos: item.supuestos,
      comision: item.comision == 'null' ? null : item.comision
    }
    if (item.id) denuncia = { id: item.id, ...denuncia }
    if (item?.estadoTramite)
      denuncia = { estadoTramite: item.estadoTramite, ...denuncia }
    if (item?.aperturaResolucion?.anio)
      denuncia = { aperturaResolucion: item.aperturaResolucion, ...denuncia }
    if (item?.destitucionResolucion?.anio)
      denuncia = {
        destitucionResolucion: item.destitucionResolucion,
        ...denuncia
      }
    if (item?.sancionResolucion?.anio)
      denuncia = { sancionResolucion: item.sancionResolucion, ...denuncia }
    if (item?.motivoBaja)
      denuncia = { motivoBaja: item.motivoBaja, ...denuncia }
    return denuncia
  } catch (e) {
    uiStore.notification.error('Error realizando mapeo de del denuncia')
    throw new Error('Error realizando mapeo del denuncia: ' + e)
  }
}
export function mapDenunciaTo(item: any): Denuncia {
  let denuncia = {
    id: item.id,
    expediente: item.expediente,
    magistrado: item.magistrado,
    estado: item.estado,
    altaFecha: item.altaFecha,
    juzgado: item.juzgado,
    supuestos: item.supuestos,
    comision: item.comision
  } as any
  if (item.estadoTramite)
    denuncia = { ...denuncia, estadoTramite: item.estadoTramite }
  if (item.aperturaResolucion)
    denuncia = { ...denuncia, aperturaResolucion: item.aperturaResolucion }
  if (item.destitucionResolucion)
    denuncia = {
      ...denuncia,
      destitucionResolucion: item.destitucionResolucion
    }
  if (item.sancionResolucion)
    denuncia = { ...denuncia, sancionResolucion: item.sancionResolucion }
  if (item.motivoBaja) denuncia = { ...denuncia, motivoBaja: item.motivoBaja }
  return denuncia
}

export function mapErrorToString(error) {
  return error?.fields?.length > 0
    ? error.fields.map((item) => item['description']).join('\n')
    : error?.message
    ? error.message
    : error
}
